import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { ConfigurationService } from 'app/masters/configuration/configuration.service';
import { referredAccoModal } from 'app/masters/models/service-master.model';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { ExportService } from 'app/reports/services/export.service';
import { Observable, Subject } from 'rxjs';
import { iterator } from 'rxjs/internal-compatibility';
import { map, startWith, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-referred-accouting-module',
  templateUrl: './referred-accouting-module.component.html',
  styleUrls: ['./referred-accouting-module.component.scss']
})
export class ReferredAccoutingModuleComponent implements OnInit {
  columnNames: string[] = ['Share Type', 'Share Per', 'Share Flat', 'After Discount'];
  private branchList: any = [];
  private filteredBranchArray: Observable<any[]>;
  private filterRefArray: Observable<any[]>;
  private BranchId: FormControl;
  private refId: FormControl;
  searchText: any;
  selectedColumnName: string | null = null;
  inputValue: any = '';
  showSpinner: boolean = false
  private refgetApiList: any = [];
  private personmasterArray: any[] = [];
  destroyReferredAccouting$: Subject<boolean> = new Subject<boolean>();
  referredAccountingModal: referredAccoModal = {};
  editCache: any = {};
  constructor(private configurationService: ConfigurationService,
    private opdvisitService: OpdVisitService,
    private exportdata: ExportService,
    private dashboardService: DashboardService
  ) { }

  ngOnInit(): void {
    this.getBranchList();
    // this.refControll();
    this.refbygetApi();
  }


  getBranchList() {
    this.configurationService.getBranchMaster().subscribe(data => {
      this.branchList = data;
      this.branchControll();
    });
  }

  branchControll() {
    this.BranchId = new FormControl();
    this.filteredBranchArray = this.BranchId.valueChanges
      .pipe(
        startWith(''),
        map(country => country ? this.filterBranchfunction(country) : this.branchList.slice())
      );
  }

  filterBranchfunction(name: string) {
    return this.branchList.filter(item =>
      item.branchName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  getbranchObj(e) {
    var val = e.option.id;
    this.referredAccountingModal.fK_BranchId = val
    // this.enabledisablebtn = false;
  }

  refbygetApi() {
    this.opdvisitService.getpersonMasterSpecific('0', 0).pipe(takeUntil(this.destroyReferredAccouting$)).subscribe((res: any) => {
      if (res.length > 0) {
        this.personmasterArray = res;
        this.refControll();
      }
    })
  }

  refControll() {
    this.refId = new FormControl();
    this.filterRefArray = this.refId.valueChanges
      .pipe(
        startWith(''),
        map(item => item ? this.filterReffunction(item) : this.personmasterArray.slice())
      );
  }

  filterReffunction(name: string) {
    return this.personmasterArray.filter(item =>
      item.personName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  getRefObj(e) {
    var val = e.option.id;
    this.referredAccountingModal.fK_ReferredbyId = val
    this.referredAccountingModal.referredBy
  }

  showrecord() {
    this.getreftableApi();
  }

  getreftableApi() {
    if (!this.referredAccountingModal.fK_BranchId) {
      this.dashboardService.openSnackBar("Please Select Branch Name", "OK")
      return;
    }

    if (!this.referredAccountingModal.fK_ReferredbyId) {
      this.dashboardService.openSnackBar("Please Select Reffred Name ", "OK")
      return;
    }
    this.showSpinner = true
    this.configurationService.GetReferredByShareDetailApi(this.referredAccountingModal.fK_BranchId, this.referredAccountingModal.fK_ReferredbyId).pipe(takeUntil(this.destroyReferredAccouting$)).subscribe((res) => {
      if (res.length > 0) {
        res.map(item => item.isEditlocal = false);
        this.refgetApiList = res;
        this.refgetApiList.sort((a, b) => b.pK_TranId - a.pK_TranId);
        this.filteredRefArray = res;
        this.showSpinner = false;
      } else {
        this.dashboardService.openSnackBar("Record Not Found", "OK")
      }
    })
  }
  filteredRefArray = [];
  filterTable() {
    this.filteredRefArray = this.refgetApiList.filter((item) =>
      item.serviceName?.toString().toLowerCase().includes(this.searchText.toLowerCase())
    );
  }

  onHeaderChange(item: any, isChecked: boolean) {
    item.isAfterDiscount = isChecked;
  }

  columnMapping = {
    'Service Name': 'serviceName',
    'Share Type': 'shareType',
    'Share Per': 'sharePer',
    'Share Flat': 'shareFlat',
    'After Discount': 'isAfterDiscount',
  };



  formatDecimal(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    let num = parseFloat(value);
    return Number.isInteger(num) ? num.toString() : num.toFixed(2);
  }


  onShareTypeChange(selectedType: string, index: number) {
    if (selectedType === 'F') {
      this.refgetApiList[index].sharePer = 0;
    } else if (selectedType === 'P') {
      this.refgetApiList[index].shareFlat = 0;
    }
  }

  updateEditCache(): void {
    this.refgetApiList.forEach((item, index) => {
      this.editCache[index] = {
        edit: false,
        data: { ...item },
      };
    });
  }

  Edit(index: number, item: any) {
    // this.refgetApiList[index].isEditlocal = true;
    this.updateEditCache();
    this.editCache[index].edit = true;
    this.refgetApiList[index].isEdit = true;

  }

  saveedit(index: number, item: any) {
    // this.refgetApiList[index].isEditlocal = false;
    this.editCache[index].edit = false;
  }

  updateColumnValues() {
    if (this.inputValue > 100) {
      this.dashboardService.openSnackBar('Share Per cannot be greater than 100', 'OK');
      return;
    }

    if (!this.inputValue) {
      this.dashboardService.openSnackBar('Please enter the value', 'OK');
      return;
    }
    const colKey = this.columnMapping[this.selectedColumnName];
    if (!colKey) return;
    for (let row of this.refgetApiList) {
      if (row[colKey] === 0 || row[colKey] === null || row[colKey] === "0") {
        row[colKey] = this.inputValue;
        row['isEdit'] = true;
      }
    }
    this.closeEditColumnWiseModal();
  }

  InsertReferredBy() {
    if (!this.referredAccountingModal.fK_BranchId) {
      this.dashboardService.openSnackBar("Please Select Branch First", "OK")
      return;
    }

    if (!this.referredAccountingModal.fK_ReferredbyId) {
      this.dashboardService.openSnackBar("Please Select Reffred Name ", "OK")
      return;
    }

    const branchnameInput = this.referredAccountingModal.branchName?.trim();
    if (branchnameInput) {
      const isInputValid = this.branchList.some(item => item.branchName?.toLowerCase() === branchnameInput.toLowerCase());
      if (!isInputValid) {
        this.dashboardService.openSnackBar("Please Select Correct Branch Name", "OK");
        return;
      }
    }
    const referralInput = this.referredAccountingModal.referredBy?.trim();
    if (referralInput) {
      const isInputValid = this.personmasterArray.some(item => item.personName?.toLowerCase() === referralInput.toLowerCase());
      if (!isInputValid) {
        this.dashboardService.openSnackBar("Please Select Correct Referral Name", "OK");
        return;
      }
    }
    let hasInvalidPer = this.refgetApiList.some(item => item.sharePer > 100);
    if (hasInvalidPer) {
      this.dashboardService.openSnackBar('Share Per cannot be greater than 100', 'OK');
      return;
    }

    this.refgetApiList.forEach((item, index) => {
      if (this.editCache[index] && this.editCache[index].edit) {
        this.editCache[index].edit = false;
      }
    });
    this.showSpinner = true;
    var insertReferredarray = []
    const reffilter = this.refgetApiList.filter(item => item.isEdit == true);
    reffilter.forEach((item) => {
      if (item.sharePer !== 0 || item.shareFlat !== 0) {
        insertReferredarray.push({
          "PK_TranId": item.pK_TranId > 0 ? item.pK_TranId : 0,
          "FK_BranchId": this.referredAccountingModal.fK_BranchId,
          "FK_ReferredbyId": this.referredAccountingModal.fK_ReferredbyId,
          "FK_ServiceId": item.fK_ServiceId,
          "ShareType": item.shareType,
          "SharePer": item.sharePer,
          "ShareFlat": item.shareFlat,
          "IsAfterDiscount": item.isAfterDiscount == "Y" ? true : item.isAfterDiscount == "N" ? false : item.isAfterDiscount,
          "IsEdit": item.pK_TranId > 0 ? true : false
        })
      }
    })
    let payload = {
      InsertReferredByShareDetail: insertReferredarray
    }
    this.configurationService.InsertReferredByShareDetail(payload).pipe(takeUntil(this.destroyReferredAccouting$)).subscribe((x) => {
      if (x['statusCode'] == 1) {
        this.getreftableApi()
        const postmassage = insertReferredarray.some(item => item.pK_TranId == 0);
        this.dashboardService.openSnackBar(postmassage ? "Record Saved Successfully" : "Record Updated Successfully", "OK");
      }
      this.showSpinner = false;
      insertReferredarray = [];
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
      this.showSpinner = false
    })
  }

  exportexcel(): void {
    this.exportdata.open_loader_Dialogtwo();
    let element = document.getElementById('content');
    this.exportdata.Newexportxcel(element, 'Referred_AccoutingModule List');

  }
  editColumnWiseModal() {
    document.getElementById('editColumnWiseModal').style.display = 'block';
  }

  closeEditColumnWiseModal() {
    document.getElementById('editColumnWiseModal').style.display = 'none';
    this.selectedColumnName = '';
    // this.selectedType = '';
    this.inputValue = '';
  }

  ngOnDestroy(): void {
    this.destroyReferredAccouting$.next(true);
    this.destroyReferredAccouting$.unsubscribe();
    this.refgetApiList = null;
    this.filteredBranchArray = null;
    this.filterRefArray = null;
    this.branchList = null;
    this.filteredRefArray = null;
    this.showSpinner = false;
    this.personmasterArray = null;
  }
}
